var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilledTickGreen2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Filled Tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Icon \xD0\xA1olor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.686 6.084L8.0316 10.884C7.8812 11.0816 7.6484 11.1984 7.4004 11.2H7.3948C7.1492 11.2 6.9172 11.0864 6.7652 10.8928L4.8196 8.4072C4.5476 8.06 4.6084 7.5568 4.9564 7.2848C5.3036 7.012 5.8076 7.0728 6.0796 7.4216L7.386 9.0904L10.4132 5.1152C10.6804 4.764 11.182 4.6952 11.5348 4.9632C11.886 5.2312 11.954 5.7328 11.686 6.084ZM0.25 8C0.25 12.4176 3.8316 16 8.25 16C12.6684 16 16.25 12.4176 16.25 8C16.25 3.5816 12.6684 0 8.25 0C3.8316 0 0.25 3.5816 0.25 8Z",
    fill: "#186222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilledTickGreen2);
export default __webpack_public_path__ + "static/media/icon-filled-tick-green-2.6ee3f9a90e53cc0f2df54074e40425f9.svg";
export { ForwardRef as ReactComponent };